import { useEffect, useState } from "react";

export default function ConfirmModal({
  open,
  title = "Are you sure?",
  body = "",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  danger = false,
  onConfirm,
  onCancel,
  loading = false,
}) {
  const isDanger = destructive || danger;
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(open); }, [open]);
  if (!open) return null;

  return (
    <div
      data-testid="confirm-modal"
      className={`fixed inset-0 z-50 flex items-center justify-center px-4 transition-opacity ${
        mounted ? "opacity-100" : "opacity-0"
      }`}
      onClick={onCancel}
    >
      <div className="absolute inset-0 bg-paper/80 backdrop-blur-sm" />
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md border border-ink/15 bg-paper p-8 flex flex-col gap-5"
      >
        <h3 className="font-display text-2xl md:text-3xl font-semibold text-ink leading-tight">
          {title}
        </h3>
        {body && <p className="text-ink/70 leading-relaxed">{body}</p>}
        <div className="flex flex-col-reverse sm:flex-row gap-3 mt-2">
          <button
            data-testid="confirm-cancel"
            onClick={onCancel}
            disabled={loading}
            className="flex-1 border border-ink text-ink py-3 text-xs font-bold uppercase tracking-widest hover:bg-paper hover:text-ink transition-colors disabled:opacity-60"
          >
            {cancelLabel}
          </button>
          <button
            data-testid="confirm-ok"
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 py-3 text-xs font-bold uppercase tracking-widest transition-colors disabled:opacity-60 ${
              isDanger
                ? "bg-destructive text-paper hover:bg-paper hover:text-destructive border border-destructive"
                : "bg-lime text-ink hover:bg-paper border border-ink"
            }`}
          >
            {loading ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
